module.exports = __webpack_public_path__ + "media/bootstrap-icons/sun-ab49f627.svg";